import React from "react"
import { View, StyleSheet, TouchableOpacity, Image } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import logo from "@assets/logo-blue.png"

/**
 * Header compact funnel Brevet : tout sur une seule ligne.
 *  - back button (28px) si pas hideBack
 *  - logo Masteur petit (auto, ~22 hauteur)
 *  - progress bar flex
 *  - step counter "1/4"
 */
const BrevetFunnelHeader = ({
    step,
    total,
    onBack,
    hideBack = false,
    hideStep = false,
    hideLogo = false,
}) => {
    const progress = hideStep ? 1 : Math.max(0, Math.min(1, step / total))
    return (
        <View style={styles.container}>
            {!hideBack ? (
                <TouchableOpacity onPress={onBack} style={styles.backButton}>
                    <FontAwesome5
                        name="chevron-left"
                        size={14}
                        color={theme.colors.light}
                    />
                </TouchableOpacity>
            ) : null}
            {!hideLogo ? (
                <Image
                    source={logo}
                    style={styles.logo}
                    resizeMode="contain"
                />
            ) : null}
            <View style={styles.progressTrack}>
                <View
                    style={[styles.progressFill, { width: `${progress * 100}%` }]}
                />
            </View>
            {hideStep ? null : (
                <TextM fontSize={11} fontWeight="Bold" color={theme.colors.light}>
                    {step}/{total}
                </TextM>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
        paddingVertical: 10,
        paddingHorizontal: 4,
        borderBottomWidth: 1,
        borderBottomColor: theme.colors.lightMore,
    },
    backButton: {
        width: 26,
        height: 26,
        alignItems: "center",
        justifyContent: "center",
    },
    logo: {
        width: 76,
        height: 22,
    },
    progressTrack: {
        flex: 1,
        height: 4,
        backgroundColor: theme.colors.lightMore,
        borderRadius: 2,
        overflow: "hidden",
    },
    progressFill: {
        height: "100%",
        backgroundColor: theme.colors.primary,
        borderRadius: 2,
    },
})

export default BrevetFunnelHeader
